import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ArrowRightIcon, ClockIcon, CompassIcon } from 'lucide-react';
import { CHECKOUT_URL, EASE, Eyebrow, PRICE_FULL, PRICE_SHORT, Section } from './Shared';
import { LuoPan } from './Decor';
const inclusions = ['Acceso inmediato', '100% PDF', 'Garantía 7 días', 'Pago seguro'];
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-196" data-mp="1wmsvz357dano">
      <span className="min-w-[62px] rounded-sm border-2 border-brand-gold bg-brand-woodDark px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight md:min-w-[86px] md:px-5 md:py-3 md:text-4xl" data-id="element-197" data-mp="20mji2tjsb2lv">
        {value}
      </span>
      <span className="mt-1.5 font-title text-[9px] uppercase tracking-[0.2em] text-brand-muted md:text-[11px]" data-id="element-198" data-mp="1rs57336aee8k">
        {label}
      </span>
    </div>;
}
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 20
  });
  const spotsTaken = 78;
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  return <div className="mx-auto mb-14 max-w-4xl" data-id="element-199" data-mp="1hfcd9lkl4at8">
      <div className="paper-panel border-2 border-brand-cinnabar/50 p-6 md:p-8" data-id="element-200" data-mp="1hiqegqhiidz3">
        <div className="mb-6 flex items-center justify-center gap-2 text-brand-cinnabarDark" data-id="element-201" data-mp="1vfdnhrmqould">
          <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-202" data-mp="1qhvclvp5w5aq" />
          <h3 className="font-title text-sm uppercase tracking-[0.16em] md:text-lg" data-id="element-203" data-mp="11cg2id4iz9o">
            Precio de lanzamiento — cierra en
          </h3>
        </div>

        <div className="mb-6 flex items-center justify-center gap-2 md:gap-4" data-id="element-204" data-mp="3satcgbhcvy56">
          <TimeBox value={format(timeLeft.h)} label="Horas" data-id="element-205" data-mp="1w75159l1cjeh" />
          <span className="pb-5 text-3xl text-brand-gold" aria-hidden="true" data-id="element-206" data-mp="213lssdrg1fwb">
            :
          </span>
          <TimeBox value={format(timeLeft.m)} label="Min" data-id="element-207" data-mp="262f7uamdpeyl" />
          <span className="pb-5 text-3xl text-brand-gold" aria-hidden="true" data-id="element-208" data-mp="2a4tn6kqu9wl4">
            :
          </span>
          <TimeBox value={format(timeLeft.s)} label="Seg" data-id="element-209" data-mp="2f4oe2oam6m66" />
        </div>

        <div className="mb-6 flex items-center justify-center gap-2.5 border border-brand-gold bg-brand-rice px-4 py-3" data-id="element-210" data-mp="2f2bwwdcokfu6">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-cinnabar" aria-hidden="true" data-id="element-211" data-mp="2ou7ulnauu3xv" />
          <p className="text-center font-title text-sm uppercase tracking-[0.08em] text-brand-ink md:text-base" data-id="element-212" data-mp="2tssvzq1uetnw">
            Después sube. <span className="text-brand-cinnabar" data-id="element-213" data-mp="2xvpab4kco3m1">No vuelve.</span>
          </p>
        </div>

        <div className="border border-brand-ink/10 bg-brand-rice p-4 md:p-5" data-id="element-214" data-mp="32usi2wrpsnxp">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-215" data-mp="r6x2o6tx5pe1">
            <span className="flex items-center gap-2.5 text-sm font-semibold text-brand-ink" data-id="element-216" data-mp="m6sud43600yw">
              <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-217" data-mp="i57b9101eqg9">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-cinnabar opacity-70" data-id="element-218" data-mp="d6m9uy91u0q8" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-cinnabar" data-id="element-219" data-mp="19xeqpy3t3wt2" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="font-title text-[11px] uppercase tracking-[0.18em] text-brand-cinnabar" data-id="element-220" data-mp="114biq5bxkc5t">
              Quedan pocos
            </span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-ink/10" role="progressbar" aria-valuenow={spotsTaken} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-221" data-mp="w58cwio4m1ws">
            <div className="h-full rounded-full bg-brand-jade" style={{
            width: `${spotsTaken}%`
          }} data-id="element-222" data-mp="18emxh71lj12q" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-223" data-mp="1desr2srfexng">
            <strong className="text-brand-jade" data-id="element-224" data-mp="ze8be5gt5hy6">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="!py-0" data-id="element-225" data-mp="1s2w0yd8lathj">
      <div className="relative overflow-hidden border-2 border-brand-jade bg-brand-paper px-5 py-12 md:px-10 md:py-16" data-id="element-226" data-mp="1s35q5ylt8wm6">
        <LuoPan className="animate-compass pointer-events-none absolute -right-20 -top-20 hidden h-72 w-72 text-brand-gold/15 md:block" data-id="element-227" data-mp="1w6bx78gqyrtp" />

        <div className="relative mx-auto mb-10 max-w-2xl text-center" data-id="element-228" data-mp="1nbe15siayyy5">
          <span className="animate-ember inline-flex items-center gap-2 rounded-sm bg-brand-jade px-4 py-1.5 font-title text-[10px] uppercase tracking-[0.2em] text-white md:text-xs" data-id="element-229" data-mp="2b1i1nr072ikx">
            <CompassIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-230" data-mp="2fub6sfzkrsxj" />
            Oferta de lanzamiento
          </span>
          <h2 className="mt-5 font-title text-2xl leading-tight text-brand-jadeDeep md:text-4xl" data-id="element-231" data-mp="2l5ewgusq8v6h">
            Tu sistema completo de <span className="title-seal" data-id="element-232" data-mp="2yx37svv5jfme">Feng Shui</span> para negocios
          </h2>
          <div className="double-rule mx-auto mt-5 w-24" aria-hidden="true" data-id="element-233" data-mp="2ty0g0d46n5wd" />
          <p className="mt-5 font-serif text-base text-brand-inkLight md:text-lg" data-id="element-234" data-mp="2u032in64mgwc">
            El precio de lanzamiento vence hoy. Después sube. No vuelve.
          </p>
        </div>

        <div className="relative mx-auto max-w-2xl space-y-5" data-id="element-235" data-mp="228nhgxk7x288">
          <div className="border border-brand-ink/12 bg-brand-rice p-6 md:p-8" data-id="element-236" data-mp="2g7dcm7nh8rty">
            <Eyebrow className="!text-brand-wood" data-id="element-237" data-mp="2b6pp3vygit4h">Feng Shui Negocios™</Eyebrow>
            <div className="mt-4 flex flex-wrap items-end justify-between gap-6" data-id="element-238" data-mp="3rlijp9izlhti">
              <div className="max-w-sm" data-id="element-239" data-mp="3rnbtuyst6k69">
                <h3 className="font-title text-lg leading-tight text-brand-jadeDeep md:text-xl" data-id="element-240" data-mp="3mn79gxos55ar">
                  3 Tomos + 6 Bonus
                </h3>
                <p className="mt-3 font-serif text-sm leading-relaxed text-brand-inkLight" data-id="element-241" data-mp="3up6mni13gf6f">
                  Diagnóstico, Mapa Bagua, activadores, curas rápidas, colores, consultorios y calendario de activación.
                  Todo en un único sistema digital.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-242" data-mp="cf4ml4zpml3c">
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-muted" data-id="element-243" data-mp="3b05yhw21k9g4">Valor original</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-244" data-mp="3fyqzhxp4ax5m">{PRICE_FULL}</p>
                <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-cinnabar" data-id="element-245" data-mp="3kwioojydo564">
                  Precio de lanzamiento
                </p>
                <p className="font-title text-4xl text-brand-cinnabar md:text-5xl" data-id="element-246" data-mp="2s94zx94u2fx3">{PRICE_SHORT}</p>
                <p className="mt-1 text-xs text-brand-muted" data-id="element-247" data-mp="2x76k5xdzwla5">Acceso inmediato</p>
              </div>
            </div>
          </div>

          <motion.a href={CHECKOUT_URL} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} transition={{
          duration: 0.14,
          ease: EASE
        }} className="cta-sweep relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-sm bg-brand-cinnabar px-6 py-5 text-center font-title text-sm uppercase tracking-[0.1em] text-white ring-2 ring-brand-gold ring-offset-2 ring-offset-brand-paper shadow-[0_14px_30px_rgba(126,22,20,0.3)] transition-colors duration-150 ease-out hover:bg-brand-cinnabarDark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-cinnabar/50 md:text-lg" data-id="element-248" data-mp="2pnoue2a5qz55">
            <span className="relative z-10 flex items-center gap-2" data-id="element-249" data-mp="1s0yg1yycxopu">
              Quiero mi pack ahora — {PRICE_SHORT}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="1n023yy3uqw9c" />
            </span>
          </motion.a>

          <ul className="grid gap-3 border border-brand-jade/30 bg-brand-jadeMist p-4 text-center sm:grid-cols-4" data-id="element-251" data-mp="1j0a4rc0cm2gn">
            {inclusions.map(item => <li key={item} className="text-xs font-semibold text-brand-jadeDeep" data-id="element-252" data-mp="3bvj5aretz3jj">
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8" data-id="element-253" data-mp="31wtypusdx5il">
      <LaunchUrgency data-id="element-254" data-mp="31z6fw5qbjbul" />
      <Pricing data-id="element-255" data-mp="2o689zpg921cs" />
    </div>;
}